const carouselImage = '.hpe-carousel__image';
const carouselActive = 'hpe-carousel__image--active';
const carouselActiveClass = `.${carouselActive}`;

$('.hpe-carousel__button--next').click(function () {
  $(this)
    .siblings(carouselActiveClass)
    .removeClass(carouselActive)
    .nextAll(carouselImage)
    .first()
    .addClass(carouselActive);
});

$('.hpe-carousel__button--previous').click(function () {
  $(this)
    .siblings(carouselActiveClass)
    .removeClass(carouselActive)
    .prevAll(carouselImage)
    .first()
    .addClass(carouselActive);
});

$('.hpe-carousel__indicator').click(function () {
  $(this)
    .prev()
    .addClass(carouselActive)
    .siblings()
    .removeClass(carouselActive);
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/header-carousel.js